<template id="FeaturesList">
    <v-app>
        <!-- <v-container class="fill-height d-flex align-center justify-center">
            <v-row justify="center">
                <v-col cols="12" class="text-center">
                    <h4 class="text-h2 font-weight-bold text-primary mb-2">Welcome</h4>
                    <p class="text-h3 text-primary font-italic mb-1">to</p>
                    <h1 class="text-h3 text-primary font-weight-bold"> {{ moduleName }}</h1>
                </v-col>
            </v-row>
        </v-container> -->


        <v-container>
            <v-row>
                <v-col cols="12" class="text-center">
                    <p class="text-h6 text-primary mb-1">Welcome to {{ moduleName }}</p>
                </v-col>

                <v-col v-if="moduleName == 'Sale Order Management'" cols="12" class="text-center">
                    <SaleDashboard ref="saleDashboardRef" />
                </v-col>

                 <v-col v-if="moduleName == 'Purchase Management'" cols="12" class="text-center">
                    <purchaseDashboard ref="purchaseDashboardRef" />
                </v-col>

                <v-col v-if="moduleName == 'Inventory Management'" cols="12" class="text-center">
                    <inventoryDashboard ref="inventoryDashboardRef" />
                </v-col>
                <v-col v-if="moduleName == 'Project Management'" cols="12" class="text-center">
                    <projectDashboard ref="projectDashboardRef" />
                </v-col>
            </v-row>
        </v-container>

    </v-app>
</template>

<script>

import breadCrumbs from '@/components/utils/breadCrumbs.vue';
import SaleDashboard from '@/components/module/sales/saleDashboard.vue';
import purchaseDashboard from '@/components/module/purchase/purchaseDashboard.vue';
import inventoryDashboard from '@/components/module/inventory/inventoryDashboard.vue';
import projectDashboard from '@/components/module/project/projectDashboard.vue';



export default {
    components: {
        SaleDashboard,
        purchaseDashboard,
        inventoryDashboard,
        projectDashboard,
        breadCrumbs,
    },
    name: 'FeaturesList',
    data: () => ({
        module_code: "",
        messageRoutes: [

            {
                path: "administration",
                name: "Administration Management"
            },
            {
                path: "inventory",
                name: "Inventory Management"
            },
            {
                path: "purchase",
                name: "Purchase Management"
            },
            {
                path: "project",
                name: "Project Management"
            },
            {
                path: "lc",
                name: "LC Management"
            },
            {
                path: "account",
                name: "Accounts Management"
            },
            {
                path: "bhp",
                name: "Buying House Production"
            },
            {
                path: "sales",
                name: "Sale Order Management"
            },
            {
                path: "hrm",
                name: "Human Resource Management"
            },
            {
                path: "attendance",
                name: "Attendance Management"
            },
            {
                path:"leave",
                name:"Leave Management"
            },
            {
                path:"payroll",
                name: "Payroll Management"
            },
            {
                path: "provident",
                name: "Provident Fund"
            },
            {
                path:"asset",
                name:"Asset Management"
            },
            {
                path:"documents",
                name:"Documentation Management"
            },
            {
                path:"task",
                name:"Task Management"
            },
            {
                path:"notification",
                name:"Notification Management"
            },
            {
                path:"resource",
                name:"Resource"
            }
        ],
    }),
    watch: {
    },
    created() {
    },
    computed: {
        getNavbarItemsFeatures() {
            var menu = JSON.parse(localStorage.getItem("menu"));
            var module_code = this.module_code;
            var data = menu.filter(function (el) {
                return el.code == module_code;
            });
            this.loading = true;
            return data;
        },
        moduleName() {
            const segments = this.$route.path.split("/");
            const module = segments[2].toLocaleLowerCase();
            const found = this.messageRoutes.find((item) => item.path === module);
            return found.name;
        }
    },
    methods: {
        goTo(val) {
            this.$router.push({ path: val }).catch(err => { });
        },
    },
    mounted() {
        this.module_code = this.$route.params.module_code;
        const array = this.$route.path.split("/")
        // console.log(array[2]);
    }
}
</script>
